export default __webpack_public_path__ + "static/media/faq.e2874691.svg";